import options from './c-badge';

export default options;